const draggableProp = 'draggableInstance';
const draggableEl = 'ui-draggable';
const draggableHandle = 'ui-draggable-handle';
const draggableHelper = 'ui-draggable-helper';
const droppableProp = 'droppableInstance';
const droppableEl = 'ui-droppable';
const droppableActive = 'ui-droppable-active';
const droppableHover = 'ui-droppable-hover';
const sortableProp = 'sortableInstance';
const sortableEl = 'ui-sortable';
const sortableHandle = 'ui-sortable-handle';
const sortableHelper = 'ui-sortable-helper';
const sortablePlaceholder = 'ui-sortable-placeholder';

export {
	draggableProp,
	draggableEl,
	draggableHandle,
	draggableHelper,
	droppableProp,
	droppableEl,
	droppableActive,
	droppableHover,
	sortableProp,
	sortableEl,
	sortableHandle,
	sortableHelper,
	sortablePlaceholder
};

export default {
	draggableProp,
	draggableEl,
	draggableHandle,
	draggableHelper,
	droppableProp,
	droppableEl,
	droppableActive,
	droppableHover,
	sortableProp,
	sortableEl,
	sortableHandle,
	sortableHelper,
	sortablePlaceholder
};
